import { useTranslation } from "react-i18next";
import { LANGS } from "@/i18n";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || "hr";

  return (
    <div className={`inline-flex items-center gap-1 ${className}`} data-testid="language-switcher">
      <Globe className="w-3.5 h-3.5 text-ink-soft mr-0.5" strokeWidth={1.75} aria-hidden="true" />
      {LANGS.map((l) => {
        const active = current === l.code;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => i18n.changeLanguage(l.code)}
            aria-label={l.name}
            aria-pressed={active}
            data-testid={`lang-${l.code}`}
            className={`px-1.5 py-1 text-xs font-semibold tracking-wide rounded-sm transition-colors ${
              active ? "text-ink" : "text-ink-soft/60 hover:text-ink"
            }`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
